import { Tab } from '@/forwarding/components/ForwardModal/ForwardModalBody/ForwardModalTabs/ForwardModalTabs';
import { ForwardModalTab } from '@/forwarding/components/ForwardModal/ForwardModalTab';

export function getAvailableTabs(hasDriveTree: boolean, hasShare: boolean, hasRecentDestinations: boolean): Tab[] {
  const tabs = [];

  if (hasDriveTree && hasRecentDestinations) {
    tabs.push({ tab: ForwardModalTab.Recent, label: 'Recent' });
  }

  if (hasDriveTree) {
    tabs.push({ tab: ForwardModalTab.DriveTree, label: 'Collections' });
  }

  if (hasShare) {
    tabs.push({ tab: ForwardModalTab.Share, label: 'Messengers & Socials' });
  }

  return tabs;
}
